
















































import {Component, Prop, PropSync} from 'vue-property-decorator'
import {Getter, Action} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {PriceWings, SelectWings, ToggleWings} from "wings-ui-components";
import {TariffFilterParams, TarificationTransports, TarificationTypes} from "@/store/tarification/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {PriceWings, SelectWings, ToggleWings}})
export default class TariffFilter extends BaseFilter<TariffFilterParams> {
  @PropSync('show') is_show!: boolean;
  @Prop() transport!: TarificationTransports;
  @Prop() type!: TarificationTypes;

  @Action("getPartners") actionGetPartners: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getTariffs") actionGetTariffs!: (data:any) => Promise<void>;

  private pushTransport: TarificationTransports = TarificationTransports.PUSH
  private partnerType: TarificationTypes = TarificationTypes.PARTNER
  private operatorType: TarificationTypes = TarificationTypes.OPERATOR

  params = {transport: this.transport.toString()};
  partnersList: any = []
  serviceProvidersList:  any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  created() {
    this.actionGetTariffs({
      filter : this.filter,
      transport: this.transport,
      tariffType: this.type,
    });
    if (this.filter.partner) this.partnersList = this.actionGetPartners({name: this.filter.partner});
    if (this.filter.service_provider) this.serviceProvidersList = this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  defaultFilter(): TariffFilterParams {
    return {
      partner:undefined,
      service_provider:undefined,
    };
  }

  storageItemName(): string {
    return `${this.transport.toLowerCase() + this.type}TariffFilter`;
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Tariff",
        addititional_info: getTranslatedParams(this.filter)
      }
      await this.actionGetTariffs({
        filter : this.filter,
        transport: this.transport,
        tariffType: this.type,
      });
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
}
